import { isAxiosError } from 'axios';

/**
 * Boundary: read a non-empty API `response.data.message` from an unknown error.
 * Returns the trimmed raw message, or undefined when absent/invalid.
 */
export const readApiErrorMessage = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) {
    return undefined;
  }

  const message = error.response?.data?.message;
  if (typeof message !== 'string') {
    return undefined;
  }

  const trimmed = message.trim();
  if (trimmed.length === 0) {
    return undefined;
  }

  return trimmed;
};

/**
 * Display: capitalize the first letter of each whitespace-separated word.
 */
export const toTitleCaseWords = (value: string): string =>
  value
    .trim()
    .split(/\s+/)
    .map(
      (word) =>
        `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
    )
    .join(' ');

/**
 * Prefer API `response.data.message` when present; otherwise return fallback.
 * API messages are title-cased for toast readability.
 */
export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  const message = readApiErrorMessage(error);
  return message !== undefined ? toTitleCaseWords(message) : fallback;
};
